import MasonryGalleryContainer from "../../../../Components/Miscellaneous/Gallery/MasonryGallery/MasonryGalleryContainer";

const MasonryGallery = () => {
  return <MasonryGalleryContainer />;
};

export default MasonryGallery;
